import React from 'react';
import { ListDivider } from 'components/List';

/**
 * Single BreadcrumbCompactListDivider component.
 * All props will be provided to the root element. */
const BreadcrumbCompactListDivider = React.forwardRef<HTMLElement, any>((props: any, ref) => (
  <ListDivider style={{ marginTop: 0 }} {...props} ref={ref} />
));

BreadcrumbCompactListDivider.displayName = 'BreadcrumbCompactListDivider';

export default BreadcrumbCompactListDivider;
